class Slug {
	refreshSlug(title) {
		const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;';
		const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------';
		const p = new RegExp(a.split('').join('|'), 'g');

		let generatedSlug = title.toString().toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with ‘and’
			.replace(/[^\w\-]+/g, '') // Remove all non-word characters
			.replace(/\-\-+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, ''); // Trim - from end of text

		return generatedSlug;
	}
}

export default Slug;
